import Chart from "chart.js/auto";

export default function stackedBarChart() {
    Alpine.data('stackedBarChart', () => ({
        chartData: [],
        currentView: 0,
        xTitle: '',
        yTitle: '',
        chart: null,
        colors:['#000F8F','#FA4692','#006DFF','#000F8F','#FA4692','#006DFF'],
        addData(data,xTitle, yTitle){
            this.xTitle = xTitle;
            this.yTitle = yTitle;
            data.map((item, index) => {
                this.chartData.push({
                        label: item.DisplayText,
                        data: item.BagPart.ContentItems.map(x => x.Data.Value.Value),
                        labels: item.BagPart.ContentItems.map(x => x.DisplayText),
                        color: this.colors[index]
                })
            })
        },
        renderChart() {
            if(this.chart == null){
                let delayed;
                const ctx = document.getElementById('stackedBarChart');
                
                const labels = this.chartData.length > 0 ? this.chartData[0].labels.map((item) => `${item}`) : [];
                this.chart = new Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: this.chartData.map((item) => {
                            return {
                                label: item.label,
                                data: item.data,
                                backgroundColor: item.color,
                            }
                        })
                    },
                    options: {
                        animation: {
                            onComplete: () => {
                                delayed = true;
                            },
                            delay: (context) => {
                                let delay = 0;
                                if (context.type === 'data' && context.mode === 'default' && !delayed) {
                                    delay = context.dataIndex * 100 + context.datasetIndex * 50;
                                }
                                return delay;
                            },
                        },
                        responsive: true,
                        indexAxis: window.innerWidth < 768 ? 'y' : 'x',
                        maintainAspectRatio: false,
                        plugins: {
                            tooltip: {
                                boxPadding: 6,
                            },
                            legend:{
                                display: false,
                            }
                        },
                        scales: {
                            y: {
                                stacked: true,
                                ticks: {
                                    color: 'black',
                                    display: function (context) {
                                        return window.innerWidth > 600;
                                    }
                                },
                                grid: {
                                    display: false
                                }
                            },
                            x: {
                                stacked: true,
                                grid:{
                                    display: false
                                }
                            }
                        }
                    }
                });
            }
        }
    }));
}